import React from "react";
import { Outlet } from "react-router-dom";

const RegistrationManagement = () => <Outlet />;

export default RegistrationManagement;
